<template>
	<div class="vlog" v-if="infoLoaded">
		<vlog-header
			:logoUrl="websiteBasicInfo.preferredLogoUrl"
			:websiteUrl="websiteBasicInfo.websiteUrl"
		></vlog-header>
		<div class="vlog-main">
			<router-view />
			<!-- <router-view :key="$route.params.key"></router-view> -->
			<!-- <vlog-home></vlog-home> -->
		</div>
		<vlog-footer></vlog-footer>
	</div>
</template>

<script>
// @ is an alias to /src
// import axios from "axios";
// import VlogHome from '@/components/vlog/containers/VlogHome.vue'
import VlogFooter from "@/components/vlog/components/VlogFooter.vue";
import VlogHeader from "@/components/vlog/components/VlogHeader.vue";
// import { processWebsiteBasicInfo } from "@/utils/website_info_processor.js";
import { useHead, useSeoMeta } from "@vueuse/head";

export default {
	setup() {},
	name: "Vlog",
	components: {
		VlogHeader,
		// VlogHome,
		VlogFooter,
	},
	data() {
		return {};
	},
	computed: {
		infoLoaded() {
			let empty =
				!this.websiteBasicInfo ||
				Object.keys(this.websiteBasicInfo).length === 0;
			// console.log("infoloaded: " + !empty);
			return !empty;
		},
		websiteBasicInfo() {
			return this.$store.state.websiteBasicInfo;
		},
	},
	watch: {
		websiteBasicInfo(newVal, oldVal) {
			// console.log(newVal);
			if (newVal && newVal != oldVal) {
				this.updateMeta();
			}
		},
	},
	methods: {
		updateMeta() {
			useHead({
				title: "视频官网 | " + this.websiteBasicInfo.name,
				meta: [
					{
						name: "title",
						content: this.websiteBasicInfo.name,
					},
					{
						name: "description",
						content: this.websiteBasicInfo.description,
					},
					{
						name: "keywords",
						content: this.websiteBasicInfo.keywords,
					},
				],
			});
			useSeoMeta({
				description: this.websiteBasicInfo.description,
				ogDescription: this.websiteBasicInfo.description,
				ogTitle: this.websiteBasicInfo.vlogDisplayTitle,
				ogImage: this.websiteBasicInfo.preferredLogoUrl,
				twitterCard: "summary_large_image",
			});

			{
				let avatarURL = this.websiteBasicInfo.avatarLogoUrl;
				if (avatarURL) {
					let existed = false;
					let meta = document.getElementsByTagName("link");
					for (let i = 0; i < meta.length; i++) {
						if (meta[i].getAttribute("rel") == "icon") {
							existed = true;
							meta[i].href = avatarURL;
						}
					}
					if (!existed) {
						let meta = document.createElement("link");
						meta.setAttribute("rel", "icon");
						meta.href = avatarURL;
						document.getElementsByTagName("head")[0].appendChild(meta);
					}
				}
			}
		},
	},
	mounted() {},
};
</script>
<style scoped>
.vlog-main {
	max-width: 632px;
	margin: 0 auto;
}
.vlog {
	background-color: white;
	min-height: 100vh;
	/* color: white; */
}
</style>
